// extracted by mini-css-extract-plugin
module.exports = {"linkWithArrowLink":"LinkWithArrow_linkWithArrowLink__RZMh_","linkWithArrowLinkIcon":"LinkWithArrow_linkWithArrowLinkIcon__3b7aU"};